import React, { useState } from 'react';
import { TableFull } from './Shared';

export default function TechnicalMasters({ db, setDb }) {
  const [activeTab, setActiveTab] = useState("machines"); 
  const [editId, setEditId] = useState(null);
  
  // TECHNICAL INPUTS
  const [val, setVal] = useState("");
  const [mcIn, setMcIn] = useState({ code: '', rpm: 5000, spc: 5, spi: 12, allowance: 10, threadFactor: 3, wastageFactor: 15 }); 
  const [mnIn, setMnIn] = useState({ code: '', desc: '', value: 0 });
  const [stIn, setStIn] = useState({ code: '', factor: 5 });
  const [fdIn, setFdIn] = useState({ fabric: '', range: '', factor: 0 });
  const [alIn, setAlIn] = useState({ dept: '', name: '', factor: 5 });

  // --- RESTORED CONNECTION LOGIC ---
  const saveToDB = async (category, type, data) => {
    try {
      const response = await fetch('https://nirvikalp.integrashion.com/api/save_universal.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category, type, data })
      });
      const result = await response.json();
      return result.id;
    } catch (e) { 
        console.error("Save failed", e);
        return Date.now(); 
    }
  };

  // --- ACTIONS ---
  const saveTechGeneric = async () => {
      if (!val.trim()) return alert("Enter Name");
      let typeMap = { trimTypes:'TRIM_TYPE', uoms:'UOM', vaProcesses:'VA_PROCESS' };
      const id = await saveToDB('common', typeMap[activeTab] || 'UNKNOWN', { name: val.trim() });
      
      const newItem = { id, name: val.trim() };
      setDb(prev => ({ 
        ...prev, 
        [activeTab]: editId ? prev[activeTab].map(x => x.id === editId ? newItem : x) : [...(prev[activeTab]||[]), newItem] 
      }));
      setVal(""); setEditId(null);
  };

  const saveMachine = async () => {
      if(!mcIn.code) return alert("Machine Name/Code Required");
      const id = await saveToDB('tech', 'MACHINE', mcIn);
      const entry = { ...mcIn, id: editId || id };
      
      setDb(prev => ({ 
        ...prev, 
        machines: editId ? prev.machines.map(m => m.id === editId ? entry : m) : [...(prev.machines||[]), entry] 
      }));
      setMcIn({ code: '', rpm: 5000, spc: 5, spi: 12, allowance: 10, threadFactor: 3, wastageFactor: 15 }); setEditId(null);
  };

  const saveTechnical = async (list, data, resetFunc, defaultState) => {
    let type = 'MANUAL';
    if(list === 'stoppages') type = 'STOPPAGE';
    if(list === 'fabricDifficulties') type = 'FABRIC_DIFF';
    if(list === 'allowances') type = 'ALLOWANCE';
    
    const id = await saveToDB('tech', type, data);
    const entry = { ...data, id: editId || id };

    setDb(prev => ({ 
        ...prev, 
        [list]: editId ? prev[list].map(x => x.id === editId ? entry : x) : [...(prev[list]||[]), entry] 
    }));
    resetFunc(defaultState); setEditId(null);
  };
  
  const editTechGeneric = (item) => { setVal(item.name); setEditId(item.id); };
  const delItem = (list, id) => { if(window.confirm("Delete?")) setDb(prev => ({ ...prev, [list]: (prev[list]||[]).filter(x => x.id !== id) })); };
  const sideBtn = (t) => ({ textAlign:'left', width:'100%', padding:'12px 20px', border:'none', borderBottom:'1px solid #f1f5f9', cursor:'pointer', background: activeTab === t ? '#eff6ff' : 'transparent', color: activeTab === t ? '#2563eb' : '#64748b', borderLeft: activeTab === t ? '4px solid #2563eb' : '4px solid transparent' });

  return (
    <div className="layout-master">
       <div className="side-rail" style={{width:'260px', background:'white', borderRight:'1px solid #e2e8f0', display:'flex', flexDirection:'column', overflowY:'auto'}}>
          <div style={{padding:'10px', background:'#f8fafc', fontWeight:'bold', fontSize:'0.75rem'}}>GENERAL</div>
          {["trimTypes", "uoms", "vaProcesses"].map(t => <button key={t} style={sideBtn(t)} onClick={()=>{setActiveTab(t); setEditId(null); setVal("");}}>{t.toUpperCase()}</button>)}
          <div style={{padding:'10px', background:'#f8fafc', fontWeight:'bold', fontSize:'0.75rem', borderTop:'1px solid #eee'}}>ENGINEERING</div>
          <button style={sideBtn("machines")} onClick={() => setActiveTab("machines")}>Machine DB</button>
          <button style={sideBtn("manual")} onClick={() => setActiveTab("manual")}>Manual Codes</button>
          <button style={sideBtn("stoppages")} onClick={() => setActiveTab("stoppages")}>Stoppage Factors</button>
          <button style={sideBtn("fabric")} onClick={() => setActiveTab("fabric")}>Fabric Difficulty</button>
          <button style={sideBtn("allowances")} onClick={() => setActiveTab("allowances")}>Allowances</button>
       </div>

       <div className="content-area" style={{flex:1, padding:'20px', overflowY:'auto'}}>
          {["trimTypes", "uoms", "vaProcesses"].includes(activeTab) && (
             <div className="card">
                <h3>MANAGE: {activeTab.toUpperCase()}</h3>
                <div className="form-row"><input value={val} onChange={e=>setVal(e.target.value)} /><button className="btn-p" onClick={saveTechGeneric}>{editId?"UPDATE":"ADD"}</button></div>
                <table className="npd-table" style={{marginTop:'20px'}}><thead><tr><th>NAME</th><th>ACTION</th></tr></thead><tbody>{(db[activeTab]||[]).map(i=><tr key={i.id}><td>{i.name}</td><td><button className="btn-edit" onClick={()=>editTechGeneric(i)}>Edit</button><button className="btn-del" onClick={()=>delItem(activeTab, i.id)}>Del</button></td></tr>)}</tbody></table>
             </div>
          )}
          {activeTab === "machines" && (
             <div className="card">
                <h3>MACHINE DATABASE</h3>
                <div className="form-row" style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr 1fr auto', gap:'10px'}}>
                    <input placeholder="Machine" value={mcIn.code} onChange={e=>setMcIn({...mcIn, code:e.target.value})}/>
                    <input placeholder="RPM" type="number" value={mcIn.rpm} onChange={e=>setMcIn({...mcIn, rpm:e.target.value})}/>
                    <input placeholder="SPC" type="number" value={mcIn.spc} onChange={e=>setMcIn({...mcIn, spc:e.target.value})}/>
                    <input placeholder="SPI" type="number" value={mcIn.spi} onChange={e=>setMcIn({...mcIn, spi:e.target.value})}/>
                    <input placeholder="Allow %" type="number" value={mcIn.allowance} onChange={e=>setMcIn({...mcIn, allowance:e.target.value})}/>
                    <input placeholder="Thread Factor" type="number" step="0.1" title="Thread consumption multiplier (length × factor = thread used)" value={mcIn.threadFactor} onChange={e=>setMcIn({...mcIn, threadFactor:e.target.value})}/>
                    <input placeholder="Wastage %" type="number" title="Thread wastage percentage to add on top of consumption" value={mcIn.wastageFactor} onChange={e=>setMcIn({...mcIn, wastageFactor:e.target.value})}/>
                    <button className="btn-p" onClick={saveMachine}>{editId?"UPD":"ADD"}</button>
                </div>
                <TableFull data={db.machines||[]} cols={['code','rpm','spc','spi','allowance','threadFactor','wastageFactor']} onEdit={i=>{setMcIn(i); setEditId(i.id)}} onDelete={id=>delItem('machines',id)} />
             </div>
          )}
          {activeTab === "manual" && (
             <div className="card"><h3>MANUAL CODES</h3><div className="form-row"><input placeholder="Code" value={mnIn.code} onChange={e=>setMnIn({...mnIn, code:e.target.value})}/><input placeholder="Desc" value={mnIn.desc} onChange={e=>setMnIn({...mnIn, desc:e.target.value})}/><input type="number" placeholder="Value" value={mnIn.value} onChange={e=>setMnIn({...mnIn, value:e.target.value})}/><button className="btn-p" onClick={()=>saveTechnical('manualCodes', mnIn, setMnIn, {code:'', desc:'', value:0})}>SAVE</button></div><TableFull data={db.manualCodes||[]} cols={['code','desc','value']} onEdit={i=>{setMnIn(i); setEditId(i.id)}} onDelete={id=>delItem('manualCodes',id)}/></div>
          )}
          {activeTab === "stoppages" && (
             <div className="card"><h3>STOPPAGE FACTORS</h3><div className="form-row"><input placeholder="Code" value={stIn.code} onChange={e=>setStIn({...stIn, code:e.target.value})}/><input type="number" placeholder="Factor" value={stIn.factor} onChange={e=>setStIn({...stIn, factor:e.target.value})}/><button className="btn-p" onClick={()=>saveTechnical('stoppages', stIn, setStIn, {code:'', factor:5})}>{editId?"UPDATE":"ADD"}</button></div><TableFull data={db.stoppages||[]} cols={['code','factor']} onEdit={i=>{setStIn(i); setEditId(i.id)}} onDelete={id=>delItem('stoppages',id)}/></div>
          )}
          {activeTab === "fabric" && (
             <div className="card"><h3>FABRIC DIFFICULTY</h3><div className="form-row"><input placeholder="Fabric" value={fdIn.fabric} onChange={e=>setFdIn({...fdIn, fabric:e.target.value})}/><input placeholder="Range" value={fdIn.range} onChange={e=>setFdIn({...fdIn, range:e.target.value})}/><input type="number" placeholder="Factor" value={fdIn.factor} onChange={e=>setFdIn({...fdIn, factor:e.target.value})}/><button className="btn-p" onClick={()=>saveTechnical('fabricDifficulties', fdIn, setFdIn, {fabric:'', range:'', factor:0})}>{editId?"UPDATE":"ADD"}</button></div><TableFull data={db.fabricDifficulties||[]} cols={['fabric','range','factor']} onEdit={i=>{setFdIn(i); setEditId(i.id)}} onDelete={id=>delItem('fabricDifficulties',id)}/></div>
          )}
          {activeTab === "allowances" && (
             <div className="card"><h3>ALLOWANCE MASTER</h3><div className="form-row"><input placeholder="Dept" value={alIn.dept} onChange={e=>setAlIn({...alIn, dept:e.target.value})}/><input placeholder="Name" value={alIn.name} onChange={e=>setAlIn({...alIn, name:e.target.value})}/><input type="number" placeholder="Factor" value={alIn.factor} onChange={e=>setAlIn({...alIn, factor:e.target.value})}/><button className="btn-p" onClick={()=>saveTechnical('allowances', alIn, setAlIn, {dept:'', name:'', factor:5})}>{editId?"UPDATE":"ADD"}</button></div><TableFull data={db.allowances||[]} cols={['dept','name','factor']} onEdit={i=>{setAlIn(i); setEditId(i.id)}} onDelete={id=>delItem('allowances',id)}/></div>
          )}
       </div>
    </div>
  );
}